// utils/loadSvg.ts

/** Nome materia -> nome file dell'icona (es. "Scienze Naturali" -> "scienzeNaturali"). */
export const toCamelCase = (name: string): string => {
  // Prima sostituisce apostrofi e altri caratteri speciali con spazi
  const nameWithSpaces = name.replace(/['\-&/]/g, ' ');

  return nameWithSpaces
    .replace(/[^\w\s]/gi, '')
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .map((word, index) =>
      index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join('');
};

export const loadSvg = async (name: string): Promise<string> => {
    try {
      const svg = await import(`../ui/Materie/${name}Deselected.svg`);
      return svg.default;
    } catch (error) {
      console.error(`Impossibile caricare l'immagine per ${name}:`, error);
      return '';
    }
  };
  
/** Precarica l'immagine così è già pronta quando chiudiamo il caricamento. */
const preloadImage = (src: string) =>
  new Promise<void>((resolve) => {
    if (!src) return resolve();
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = src;
  });

/** Carica in parallelo le icone delle materie (nome materia -> url) e attende che siano scaricate. */
export const loadSubjectIcons = async (names: string[]): Promise<Record<string, string>> => {
  const entries = await Promise.all(names.map(async (name) => [name, await loadSvg(toCamelCase(name))] as const));
  await Promise.all(entries.map(([, src]) => preloadImage(src)));
  return Object.fromEntries(entries);
};
